import { LinkPreview } from 'types/common';

import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';

import { useModalContext } from 'shared/components/Modal';

import { ChatMessageScheduleModalContent } from './ScheduleModalContent';

type ScheduledAttachmentModalProps = {
  onBackButtonClick: (files: File[], text?: string) => void;
  onSubmit: (
    text: string,
    files: UnuploadedAttachment[],
    scheduledFor: string,
    linkPreview?: LinkPreview
  ) => void;
};

export const ChatMessageScheduledAttachmentModal = ({
  onBackButtonClick,
  onSubmit,
}: ScheduledAttachmentModalProps) => {
  const { text, files }: { text: string; files: UnuploadedAttachment[] } =
    useModalContext();

  const onScheduledForSelect = (scheduledFor: string) => {
    onSubmit(text, files, scheduledFor);
  };

  const handleBackButtonClick = () => {
    onBackButtonClick(
      files.map((attachment) => attachment.file),
      text
    );
  };

  return (
    <ChatMessageScheduleModalContent
      onBackButtonClick={handleBackButtonClick}
      onSubmit={onScheduledForSelect}
    />
  );
};
